import { injectable } from 'inversify';
import { plainToClass } from 'class-transformer';

import { HttpService } from '@vk-hr-tek/core/http';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { Filter, FilterService, FilterType } from '@vk-hr-tek/core/filter';

import {
  CreateEventBatchDocumentZipResponse,
  EventPdfResponse,
  CreateEventBatchDocumentZipRequest,
} from '@app/gen/events';

import { GetEventsDto, GetEventsPdfDto } from '../dto';

@injectable()
export class EventsDownloadService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
    private filterService: FilterService,
    private validator: ValidationService,
  ) {}

  async startDownload(
    batchDownloadStartDto: CreateEventBatchDocumentZipRequest,
  ) {
    const { event_ids: eventIds, with_file_attributes: withFileAttrs } =
      batchDownloadStartDto;

    return this.unmarshaller.unmarshall(
      await this.http.post(
        '/event/batch/document/zip',
        {
          event_ids: eventIds,
          with_file_attributes: withFileAttrs,
        },
        { withSide: true },
      ),
      CreateEventBatchDocumentZipResponse,
    );
  }

  async startDownloadEventsPdf(
    getEventsPdfDto: GetEventsPdfDto,
    availableFilters: Filter[],
  ) {
    const { event_ids: events } = getEventsPdfDto;

    const eventsDto = plainToClass(
      this.filterService.buildDto(GetEventsDto, availableFilters),
      getEventsPdfDto,
    );

    await this.validator.validateOrReject(eventsDto);

    const filters: FilterType = eventsDto.filters;

    const result = await this.unmarshaller.unmarshall(
      await this.http.post(
        `/event/pdf`,
        {
          ...(eventsDto.filters ? { filters } : { event_ids: events }),
        },
        {
          withSide: true,
        },
      ),
      EventPdfResponse,
    );
    return result;
  }
}
